import React from 'react';
import { copy } from '../data/noklar';
export function Guarantee() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-28" data-id="element-136" data-mp="1o3nchyuj2iwb">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-10 text-center sm:flex-row sm:gap-14 sm:text-left" data-id="element-137" data-mp="1o5q1qgnuw7zz">
        <svg viewBox="0 0 200 200" className="h-40 w-40 shrink-0 -rotate-6 text-red-700 sm:h-44 sm:w-44" role="img" aria-label="7 dagars nöjdhetsgaranti" data-id="element-138" data-mp="1x4bq4sg0eh8o">
          <defs data-id="element-139" data-mp="19fadsu422ly4">
            <path id="guarantee-stamp-path" d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0" data-id="element-140" data-mp="19co8z28jukjl" />
          </defs>
          <circle cx="100" cy="100" r="95" fill="none" stroke="currentColor" strokeWidth="3" data-id="element-141" data-mp="1j4k8mhqaaipx" />
          <circle cx="100" cy="100" r="64" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-142" data-mp="1edu2h2a1abu6" />
          <text fill="currentColor" fontSize="14" fontWeight="700" letterSpacing="2" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-143" data-mp="1ec0wzqb5pxnr">
            <textPath href="#guarantee-stamp-path" textLength="498" lengthAdjust="spacing" data-id="element-144" data-mp="lpy7q340yu01">
              NÖJDHETSGARANTI · KÖP MED TRYGGHET ·
            </textPath>
          </text>
          <text x="100" y="112" textAnchor="middle" fill="currentColor" fontSize="64" fontFamily="ui-serif, Georgia, serif" data-id="element-145" data-mp="tyco8a7dgxo9">
            7
          </text>
          <text x="100" y="136" textAnchor="middle" fill="currentColor" fontSize="13" fontWeight="700" letterSpacing="3" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-146" data-mp="yq4hishwxhi3">
            DAGAR
          </text>
        </svg>

        <div data-id="element-147" data-mp="63072801wayx">
          <h2 className="font-serif text-4xl leading-tight tracking-tight text-slate-900 sm:text-5xl" data-id="element-148" data-mp="azgvz4f2qtd2">
            {copy.guarantee.title}
          </h2>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-slate-900/75" data-id="element-149" data-mp="ezsjcoytn7s8">
            {copy.guarantee.text}
          </p>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-slate-900/60" data-id="element-150" data-mp="jy2fp2wa8eff">
            {copy.guarantee.legal}
          </p>
        </div>
      </div>
    </section>;
}